import React, { ReactNode } from "react";
import styled from "styled-components";

interface TableLayoutProps {
	children: ReactNode;
	selectable?: boolean;
}

const TableLayout: React.FC<TableLayoutProps> = ({ children, selectable = true }) => {
	return <TableLayoutStyles selectable={selectable}>{children}</TableLayoutStyles>;
};

export default TableLayout;

const TableLayoutStyles = styled.div<Pick<TableLayoutProps, "selectable">>`
	table {
		width: 100%;
		border-collapse: collapse;
	}

	td,
	th {
		padding: 0.7rem;
		height: 3.125rem;
	}

	tr {
		${(props) => props.selectable && "cursor: pointer;"}
	}

	tr:nth-child(odd) {
		background-color: ${(props) => props.theme.colors.COLOR_OFF_WHITE};
	}

	tr:hover {
		background-color: ${(props) => props.theme.colors.COLOR_HOVER_ROW};
	}

	th {
		text-align: left;
		cursor: pointer;
		font-size: ${(props) => props.theme.fontSizes.FONT_SIZE_M};
		font-weight: ${(props) => props.theme.fontWeight.FONT_WEIGHT_MEDIUM};
		background: ${(props) => props.theme.colors.COLOR_LIGHT_GRAY};
	}

	tbody td {
		border-color: #e7e7e7;
		border-style: solid;
		border-width: 1px 0 0 0;
	}

	tbody {
		tr.warning {
			background-color: ${(props) => props.theme.colors.COLOR_DANGER_LIGHT};

			td {
				border-color: #ded5d5;
				border-bottom-width: 1px;
			}
		}

		tr.notice {
			background-color: #fffcdb;

			td {
				border-color: #ded5d5;
				border-bottom-width: 1px;
			}
		}

		tr.success {
			background-color: ${(props) => props.theme.colors.COLOR_SUCCESS_LIGHT};

			td {
				border-color: #b2cbb0;
				border-bottom-width: 1px;
			}
		}

		tr.disabled {
			background-color: ${(props) => props.theme.colors.COLOR_LIGHT_GRAY};

			td {
				color: ${(props) => props.theme.colors.COLOR_GRAY_TEXT_DARK};
			}
		}
	}

	tbody tr:last-child td {
		border-width: 1px 0;
	}
`;

export const ActionsTableDataStyles = styled.td`
	padding: 0.75rem;
	min-height: 3.125rem;
	text-align: right;
	align-items: center;
	cursor: pointer;
	img {
		width: 1rem;
	}
`;

export const ActionsTableHeadStyles = styled.th`
	display: flex;
	justify-content: flex-end;
	cursor: pointer;
`;
